import { render, staticRenderFns } from "./PlanningOrders.vue?vue&type=template&id=63d79e66&"
import script from "./PlanningOrders.vue?vue&type=script&lang=js&"
export * from "./PlanningOrders.vue?vue&type=script&lang=js&"
import style0 from "./PlanningOrders.vue?vue&type=style&index=0&id=63d79e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports